module.exports = __webpack_public_path__ + "media/images/tiedye/cotton-candy-31eb49ae9d677e121b16cd78543500e6.jpg";